// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorUsageMessage, ElevatorUsageMessageT } from "./elevator-usage-message";
import { EscalatorUsageMessage, EscalatorUsageMessageT } from "./escalator-usage-message";

export enum DeviceUsageContent {
  NONE = 0,
  ElevatorUsageMessage = 1,
  EscalatorUsageMessage = 2,
}

export function unionToDeviceUsageContent(
  type: DeviceUsageContent,
  accessor: (
    obj: ElevatorUsageMessage | EscalatorUsageMessage,
  ) => ElevatorUsageMessage | EscalatorUsageMessage | null,
): ElevatorUsageMessage | EscalatorUsageMessage | null {
  switch (DeviceUsageContent[type]) {
    case "NONE":
      return null;
    case "ElevatorUsageMessage":
      return accessor(new ElevatorUsageMessage())! as ElevatorUsageMessage;
    case "EscalatorUsageMessage":
      return accessor(new EscalatorUsageMessage())! as EscalatorUsageMessage;
    default:
      return null;
  }
}

export function unionListToDeviceUsageContent(
  type: DeviceUsageContent,
  accessor: (
    index: number,
    obj: ElevatorUsageMessage | EscalatorUsageMessage,
  ) => ElevatorUsageMessage | EscalatorUsageMessage | null,
  index: number,
): ElevatorUsageMessage | EscalatorUsageMessage | null {
  switch (DeviceUsageContent[type]) {
    case "NONE":
      return null;
    case "ElevatorUsageMessage":
      return accessor(index, new ElevatorUsageMessage())! as ElevatorUsageMessage;
    case "EscalatorUsageMessage":
      return accessor(index, new EscalatorUsageMessage())! as EscalatorUsageMessage;
    default:
      return null;
  }
}

export type DeviceUsageContentT =
  | { type: "NONE"; value: null }
  | { type: "ElevatorUsageMessage"; value: ElevatorUsageMessageT }
  | { type: "EscalatorUsageMessage"; value: EscalatorUsageMessageT };
